import type { GetVerificationResponse } from './types';

type VerificationType = 'email' | 'mobile';

import { getGenericEndpoint } from './get.api';

export const getVerification = async (type: VerificationType = 'email', lang?: string) => {
	return await getGenericEndpoint<GetVerificationResponse>(`verify/${type}`, lang);
};
